<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="36.041"
    height="39.887"
    viewBox="0 0 36.041 39.887"
    class="scaling-svg"
  >
    <g transform="translate(-433 -419.5)">
      <path
        d="M34.561,33.033H25.537a1.48,1.48,0,1,1,0-2.96h7.543V15.742H2.96V30.073H10.4a1.48,1.48,0,1,1,0,2.96H1.48A1.482,1.482,0,0,1,0,31.553V9A1.481,1.481,0,0,1,.868,7.651L17.408.132a1.483,1.483,0,0,1,1.224,0l16.54,7.519A1.483,1.483,0,0,1,36.041,9V31.553A1.482,1.482,0,0,1,34.561,33.033ZM18.02,3.106,2.96,9.952v2.83H33.081V9.952L18.02,3.106Z"
        transform="translate(433 419.5)"
      />
      <path
        d="M2.96,7.495V1.48A1.48,1.48,0,1,0,0,1.48V7.495a1.48,1.48,0,1,0,2.96,0Z"
        transform="translate(449.54 437.544)"
      />
      <path
        d="M2.96,7.495V1.48A1.48,1.48,0,1,0,0,1.48V7.495a1.48,1.48,0,1,0,2.96,0Z"
        transform="translate(442.021 437.544)"
      />
      <path
        d="M1.48,0A1.48,1.48,0,0,0,0,1.48V7.495a1.48,1.48,0,1,0,2.96,0V1.48A1.48,1.48,0,0,0,1.48,0Z"
        transform="translate(457.058 437.544)"
      />
      <path
        d="M1.8,2.926a1.135,1.135,0,0,1,1.935.8.736.736,0,0,0,1.472,0,2.61,2.61,0,0,0-1.87-2.5V.736a.736.736,0,1,0-1.472,0v.491A2.517,2.517,0,0,0,1.6,5.977l1.451.6a1.041,1.041,0,0,1,.386,1.661,1.136,1.136,0,0,1-1.964-.772A.736.736,0,1,0,0,7.467a2.605,2.605,0,0,0,1.87,2.5v.493a.736.736,0,0,0,1.472,0V9.964a2.583,2.583,0,0,0,1.1-.645,2.514,2.514,0,0,0-.826-4.1l-1.451-.6A1.04,1.04,0,0,1,1.8,2.926Z"
        transform="translate(448.413 447.693)"
        stroke="rgba(0,0,0,0)"
        stroke-miterlimit="10"
        stroke-width="1"
      />
    </g>
  </svg>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class BankIcon extends Vue {}
</script>

<style></style>
